import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-y border-line bg-white px-4 py-20" data-id="element-120">
      <div className="mx-auto max-w-4xl" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-3xl border border-navy/20 bg-white p-8 text-center shadow-sm sm:p-12" data-id="element-122">
          <div className="absolute inset-x-0 top-0 h-1 bg-orange" data-id="element-123" />
          <div className="mx-auto flex size-20 items-center justify-center rounded-full border-4 border-navy bg-soft" data-id="element-124">
            <ShieldCheckIcon size={42} className="text-orange" data-id="element-125" />
          </div>
          <h2 className="mt-6 font-display text-3xl font-bold text-navy sm:text-4xl" data-id="element-126">
            Your investment is 100% protected
          </h2>
          <p className="mt-3 font-semibold text-orange" data-id="element-127">
            Complete 7-Day Money-Back Guarantee — No Questions Asked
          </p>
          <div className="mx-auto mt-6 max-w-2xl space-y-5 text-base leading-relaxed text-slate-600 sm:text-lg" data-id="element-128">
            <p data-id="element-129">
              You have 7 full days to explore the entire system, review all
              modules, implement the class structures, and evaluate the results
              with your students.
            </p>
            <p className="font-medium text-navy" data-id="element-130">
              If you are not completely satisfied — for any reason, at any point
              within those 7 days — we will refund 100% of your money.
            </p>
            <p className="font-bold text-orange" data-id="element-131">
              Zero risk. No questions. No obstacles. No fine print.
            </p>
            <p className="pt-3 text-sm text-slate-500" data-id="element-132">
              You decide. We respect that.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}